import AWS, { S3 } from 'aws-sdk';
import { ChangeEvent, MouseEvent, useState } from 'react';

const S3Upload = (): JSX.Element => {
  //#region AWS access
  const S3publicKey: string | undefined = process.env.REACT_APP_AWS_S3_PUBLIC_KEY;
  const s3privateKey: string | undefined = process.env.REACT_APP_AWS_S3_PRIVATE_KEY;
  
  if (S3publicKey === undefined) {
    throw new Error("REACT_APP_AWS_S3_PUBLIC_KEY environment variable is not found. Add .env file in the root folder of the project and assign value to this variable.");
  }

  if (s3privateKey === undefined) {
    throw new Error("REACT_APP_AWS_S3_PRIVATE_KEY environment variable is not found. Add .env file in the root folder of the project and assign value to this variable.");
  }

  // Configure AWS SDK
  AWS.config.update({
    accessKeyId: S3publicKey,
    secretAccessKey: s3privateKey,
    region: 'eu-central-1',
  });
  //#endregion

  const s3: S3 = new AWS.S3();
  const [file, setFile] = useState<File | null>(null);

  function handleFileChange(e: ChangeEvent<HTMLInputElement>): void {
    if (e.target.files !== null) {
      setFile(e.target.files[0]);
    }
  };

  function uploadToAwsS3(event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>): void {
    if (!file) {
      alert('Please select a file');
      return;
    }

    const params = {
        Bucket: 'sharp-it-cvs', // Replace with your bucket name
        Key: file.name, // File name in S3
        Body: file, // File object
        ContentType: file.type, // File type (e.g., 'image/png')
    };

    s3.upload(params, (err: Error, data: S3.ManagedUpload.SendData) => {
      if (err) {
        console.error('Error uploading file:', err);
        alert('Failed to upload file');
      } else {
        console.log('File uploaded successfully:', data.Location);
        alert('File uploaded successfully!');
      }
    });
  }

  return (
    <div>
      <h1>Upload File to S3</h1>
      <input type="file" onChange={(event: ChangeEvent<HTMLInputElement>) => handleFileChange(event)} />
      <button onClick={(event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => uploadToAwsS3(event)}>Upload file</button>
    </div>
  )
}

export default S3Upload